import Cookies from "js-cookie";
import languages from "../../localization/Languages";
import {createTheme, responsiveFontSizes} from "@mui/material/styles";
import typography from "./typography";
import overrideComponents from "./overrideComponents";
import palette from "./palette";

const currLangCode = Cookies.get("i18next") || "en";
const currLang = languages.find((l) => l.code === currLangCode);

const direction = currLang.dir || "ltr";

let theme = createTheme({
    direction: direction,
    components: {
        ...overrideComponents(direction)
    },
    palette: {
        ...palette
    },
    typography: {
        ...typography,
    }
})

// theme = responsiveFontSizes(theme, {
    // factor: 2,                  // make scaling a bit more noticeable [Default]
    // breakpoints: ['sm', 'md', 'lg'], // custom range
// });

export default theme;
